import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};

class PartyForm {
	account_name:string;
	address : string;
	branch: string;
	contact_no: string;
}

@Injectable()
export class PartyService {

	private url = environment.url

	constructor(private http: HttpClient) { }


	addNewParty(form): Observable<string>{
		return this.http.post<string>(this.url + '/masters/party/submit', form, http_options);
	};
	getAllParty(): Observable<PartyForm[]>{
		return this.http.get<PartyForm[]>(this.url + '/masters/party/all');
	};
	getPartyFormWith(name:string): Observable<PartyForm[]> {
		console.log (this.http.get<PartyForm[]>(this.url + '/masters/party/get/' + name));
		return this.http.get<PartyForm[]>(this.url + '/masters/party/get/' + name);
	};
}




// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/_services/_masters/party.service.ts